(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const closeMenus = (restoreFocus = false) => {
    document.querySelectorAll('.mobile-menu[open]').forEach(menu => {
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary').focus();
    });
  };
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a');
    if (anchor) closeMenus();
    if (!event.target.closest('.mobile-menu')) closeMenus();
    const serviceLink = event.target.closest('[data-service]');
    if (serviceLink) {
      const select = document.querySelector('[data-service-select]');
      if (select) select.value = serviceLink.dataset.service;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenus(true);
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest('.mobile-menu')) closeMenus();
  });
  window.matchMedia('(min-width: 801px)').addEventListener('change', event => {
    if (event.matches) closeMenus();
  });
  const enhance = (root = document) => {
    root.querySelectorAll('[data-tilt]').forEach(element => {
      if (element.dataset.enhanced) return;
      element.dataset.enhanced = 'true';
      element.addEventListener('pointermove', event => {
        if (reducedMotion.matches || !finePointer.matches || !document.body.classList.contains('motion-enabled')) return;
        const box = element.getBoundingClientRect();
        element.style.setProperty('--ry', `${((event.clientX - box.left) / box.width - .5) * 7}deg`);
        element.style.setProperty('--rx', `${-((event.clientY - box.top) / box.height - .5) * 7}deg`);
      });
      element.addEventListener('pointerleave', () => {
        element.style.setProperty('--ry', '0deg');
        element.style.setProperty('--rx', '0deg');
      });
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.enhanced) return;
      select.dataset.enhanced = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const parent = select.closest('[data-product]');
        if (!option || !parent) return;
        const price = parent.querySelector('[data-price]');
        const button = parent.querySelector('[data-add-to-cart]');
        if (price) price.textContent = option.dataset.price;
        if (button) {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
        }
        const image = parent.querySelector('[data-product-image]');
        if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    });
    const success = root.querySelector('.form-success');
    if (success && window.location.hash.includes('ContactForm')) success.focus();
  };
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('shopify:section:unload', () => closeMenus());
  let frame = false;
  const progress = document.querySelector('.scroll-progress');
  if (progress) window.addEventListener('scroll', () => {
    if (frame) return;
    frame = true;
    requestAnimationFrame(() => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = `${max > 0 ? Math.min(100, window.scrollY / max * 100) : 0}%`;
      frame = false;
    });
  }, { passive: true });
})();
